<template>
  <div>
    <input
      type="file"
      class="position--absolute top--0px left--0px z--10 w--100% h--100% cursor--pointer opacity--0"
      @change="handleFileAdd({$event, url: '/api/resources'})"
      :ref="name"
      :accept="acceptStr"
    >

    <!-- <form-error
      :error="error"
      :name="name"
    ></form-error> -->
    <!-- <help-text label="권장 크기 : 640 x 640 (윈도대상 750 x 1000)"></help-text> -->
    <!-- <help-text :label="helpText"></help-text> -->
  </div>
</template>

<script>
// import focusOnError from '@/component/ui/focusOnError'
import upload from '@/component/js/upload'

export default {
  mixins: [upload],
  props: {
    name: { type: String, required: true },
    fileName: { type: String },
    helpText: { type: String, default: '' },
    uploadStatus: { type: String, default: '' },
    accept: { type: Array }
  },
  data () {
    return {
      error: {}
    }
  },
  components: {
    // FormError: () => import('@/component/ui2/form/FormError'),
    // HelpText: () => import('@/component/ui2/common/HelpText')
  }
}

</script>
